jQuery.feature_import("js-auto-submit",
  () => require("./auto-submit.js"),
  mod => mod.feature_js_auto_submit
);